import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, exhaustMap, catchError } from 'rxjs/operators';

import { ReportGroupsApiService } from 'src/app/pages/administration/report-groups/services/report-groups-api.service';
import { MapReportGroupActions } from './map-report-group.actions';

export const reportGroupCreated$ = createEffect(
  (actions$ = inject(Actions), reportGroupsApiService = inject(ReportGroupsApiService)) =>
    actions$.pipe(
      ofType(MapReportGroupActions.createReportGroup),
      exhaustMap(({ payload, source, pageId }) =>
        reportGroupsApiService.createReportGroup('0', payload).pipe(
          map(() => MapReportGroupActions.createReportGroupSuccess({ source, pageId })),
          catchError(() => of(MapReportGroupActions.createReportGroupSuccess({ source, pageId })))
        )
      )
    ),
  { functional: true }
);
